// 依頼受付・詳細登録結果基底model
export class ReceptionSaveResultBase {
  public success: boolean;
  public id: number;
  public message: string;
  public reason: string;
  public archiveId: number;
  public isCommentRegistrationFailure: boolean;
  public commentId?: number;
}
